<template>
  <div class="home">
    <StudioHeader/>
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <main class="main">
      <StudioIntro/>
      <div class="main__inner">
        <!--<BackButton v-if="!isDashboard"/>-->
        <router-view></router-view>
      </div>
    </main>

    <StudioFooter/>


  </div>

</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue';
import StudioHeader from '../components/studios/StudioHeader';
import StudioIntro from "../components/studios/StudioIntro";
import StudioFooter from "../components/studios/StudioFooter";
//import BackButton from "../elements/BackButton";

export default {
  name: 'Home',
  components: {
//    HelloWorld,
    StudioHeader,
    StudioIntro,
//    BackButton,
    StudioFooter
  },
  computed: {
      isDashboard() {
        return this.$route.path.includes('dashboard') || this.$route.path.includes('check-in')
      }
  }
}
</script>
<style lang="sass" scoped>
  .home
    height: 100%
    display: flex
    flex-direction: column
  .main
    flex: 1
    &__inner
      padding-top: 36px
      padding-bottom: 40px

      +r(1023)
        padding-top: 32px

      +r(599)
        padding-top: 24px

    flex-shrink: 0
</style>
